let isViewportCoverSet = false;

const addViewportFitCover = () => {
    if (!isViewportCoverSet) {
        isViewportCoverSet = true;
        const viewportMetaTag =
            document &&
            document.getElementsByName('viewport') &&
            document.getElementsByName('viewport')[0];
        const contentValue = viewportMetaTag.getAttribute('content');
        const newContentValue = contentValue + ', viewport-fit=cover';

        viewportMetaTag.setAttribute('content', newContentValue);
    }
};
export default addViewportFitCover;
